
<template>
  <div :class="['main-navbar', 'bg-white', stickyTop ? 'sticky-top' : '']">
       <main-sidebar :items="sidebarItems" />
    <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
      <navbar-search />
      <navbar-nav />
      <navbar-toggle />
    </d-navbar>
    <div class="row">


    <div class="col-md-3 col-lg-2">
        <label>&nbsp;</label>
      </div>
          <div class="col-12 col-md-9 col-lg-10">
        <router-view/>
      </div>
</div>
  </div>
</template>

<script>

import getSidebarItems from '@/data/sidebar-nav-items';
import NavbarSearch from './NavbarSearch.vue';
import NavbarNav from './NavbarNav.vue';
import NavbarToggle from './NavbarToggle.vue';
import MainSidebar from '@/components/layout/MainSidebar/MainSidebar.vue';

export default {
  components: {
    NavbarSearch,
    NavbarNav,
    NavbarToggle,
    MainSidebar,

  },
    data() {
    return {
      sidebarItems: getSidebarItems(),
    };
  },
  props: {
    /**
       * Whether the main navbar should be sticky, or not.
       */
    stickyTop: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.main-navbar {
  .dropdown-menu {
    display: block;
  }
}
</style>
